export default "__VITE_ASSET__Bkpm9D2N__"